import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutDrsPayeeList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceDrsPayee: DataSource;
    tableDrsPayee: Table;
}
